import { Grid } from '@mui/material'

import StickyHeader from '../../../components/sticky-header'

import AlertsSection from './components/alerts-section'
import DeviceInfoSection from './components/device-info-section/device-info-section'
import StatusSection from './components/status-section/status-section'
import SummarySection from './components/summary-section'
import TrendsSection from './components/trends-section/trends-section'
import classes from './index.styles'

interface IProps {
  device: IDeviceType | null
  refetchDevice?: () => void
}

const Device = (props: IProps) => {
  const { device, refetchDevice } = props

  return (
    <>
      <StickyHeader zIndex={1300} includeTopCover={true}>
        <SummarySection device={device} refetchDevice={refetchDevice} />
      </StickyHeader>
      <Grid container={true} size={12} sx={classes.sectionContainer}>
        <StatusSection device={device} />
        <AlertsSection device={device} />
        <TrendsSection device={device} />
        <DeviceInfoSection device={device} />
      </Grid>
    </>
  )
}

export default Device
